document.addEventListener("DOMContentLoaded", function () {
  const mainImage = document.querySelector('[id^="dynamic-main-image-"]');
  const accordions = document.querySelectorAll(".accordion details");

  // ✅ STEP 1: First open by default
  if (accordions.length > 0) {
    const firstItem = accordions[0];
    firstItem.setAttribute("open", true);

    const firstImage = firstItem.getAttribute("data-main-image");
    if (firstImage && mainImage) {
      mainImage.src = firstImage;
    }
  }

  // ✅ STEP 2: Only one open at a time
  accordions.forEach((item) => {
    item.addEventListener("toggle", function () {
      if (this.open) {
        // close all others
        accordions.forEach((other) => {
          if (other !== this) {
            other.removeAttribute("open");
          }
        });

        // change image
        const newImage = this.getAttribute("data-main-image");
        if (newImage && mainImage) {
          mainImage.src = newImage;
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // select the button wrapper (image section)
  const button = document.querySelector(".collapsible-content__media .button");

  // select last accordion block
  const accordionWrap = document.querySelector(".accordion:last-of-type");

  if (button && accordionWrap) {
    // move button after last accordion
    accordionWrap.insertAdjacentElement("afterend", button);
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const buttons = document.querySelectorAll("a.button.button--primary");

  buttons.forEach(function (btn) {
    btn.classList.add("site-main-btn");
  });

});

function toggleDescription(el) {
  var parent = el.closest('.product__description');
  var shortText = parent.querySelector('.desc-short');
  var fullText = parent.querySelector('.desc-full');

  if (shortText.style.display === "none") {
    shortText.style.display = "block";
    fullText.style.display = "none";
  } else {
    shortText.style.display = "none";
    fullText.style.display = "block";
  }
}

// document.addEventListener("DOMContentLoaded", function () {

//   const colorImageMap = {
//     Brown: "https://cdn.shopify.com/s/files/1/1060/4779/9635/files/Maskgroup_12.png?v=1776142073",
//     Green: "https://cdn.shopify.com/s/files/1/1060/4779/9635/files/Mask_group_13.png?v=1776150363",
//     Blue: "https://cdn.shopify.com/s/files/1/1060/4779/9635/files/Mask_group_14.png?v=1776150390",
//     Red: "https://cdn.shopify.com/s/files/1/1060/4779/9635/files/Maskgroup_12.png?v=1776142073"
//   };

//   const labels = document.querySelectorAll('.product-form__input--pill label');

//   labels.forEach(label => {
//     const text = label.innerText.trim();

//     if (colorImageMap[text]) {
//       label.innerHTML = `<img src="${colorImageMap[text]}" style="width:100%; height:100%; object-fit:cover;">`;
//     }
//   });

// });
// document.addEventListener("DOMContentLoaded", function () {

//   function updateProductGallery(color) {
//     const selectedColor = color.toLowerCase().trim();

//     const gallery = document.querySelector(
//       '#Slider-Gallery-template--29657564643667__main'
//     );

//     if (!gallery) return;

//     const items = gallery.querySelectorAll(".product__media-item");

//     let selectedItem = null;

//     items.forEach((item) => {
//       const img = item.querySelector("img");
//       if (!img) return;

//       const alt = (img.alt || "").toLowerCase().trim();

//       item.classList.remove("is-active");

//       if (alt === selectedColor) {
//         selectedItem = item;
//       }
//     });

//     if (selectedItem) {
//       // selected image active
//       selectedItem.classList.add("is-active");

//       // move selected image to first
//       gallery.prepend(selectedItem);

//       // smooth scroll
//       selectedItem.scrollIntoView({
//         behavior: "smooth",
//         block: "nearest",
//         inline: "start"
//       });
//     }
//   }

//   // color change
//   document.addEventListener("change", function (e) {
//     if (
//       e.target.matches('input[type="radio"]') &&
//       e.target.name.toLowerCase().includes("color")
//     ) {
//       updateProductGallery(e.target.value);
//     }
//   });

//   // default selected color
//   const checked = document.querySelector(
//     'input[type="radio"]:checked[name*="COLOR"], input[type="radio"]:checked[name*="Color"]'
//   );

//   if (checked) {
//     setTimeout(() => {
//       updateProductGallery(checked.value);
//     }, 300);
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/cart/add"]');
console.log("JS Loaded")
  if (!form) {
    console.log('Product form not found');
    return;
  }

  // Get product JSON safely
  let productData = null;
  const productJsonEl = document.querySelector('[id^="ProductJson-"]');

  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      console.log('JSON parse error', e);
    }
  }
  console.log(productData);
  if (!productData || !productData.variants) {
    console.log('Product JSON missing or invalid');
    return;
  }

  
function updateGallery() {
  document.querySelectorAll('media-gallery [data-media-id]').forEach(item => {
    item.style.removeProperty('display');
  });
}

  // Run on load
  updateGallery();

  // Run on variant change
  form.addEventListener('change', function () {
    setTimeout(updateGallery, 100); // wait for Shopify to update variant ID
  });
});

document.addEventListener("DOMContentLoaded", function () {

  var accordion = document.querySelector('#shopify-section-template--29657564643667__custom_product_tabs_URb6dP');
  var productForm = document.querySelector('product-form');

  if (accordion && productForm) {
    productForm.insertAdjacentElement("afterend", accordion);
  }

});
document.addEventListener("DOMContentLoaded", function () {
  const variantSelects = document.querySelector("variant-selects");
  const sizeChart = document.querySelector(
    "#shopify-section-template--29657564643667__size_chart_variant_cGUgh3"
  );

  if (variantSelects && sizeChart) {
    variantSelects.insertAdjacentElement("afterend", sizeChart);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const productInfoWrapper = document.querySelector(".product__info-wrapper");
  const sizeModal = document.getElementById("sizeGuideModal");

  if (productInfoWrapper && sizeModal) {
    productInfoWrapper.insertAdjacentElement("afterend", sizeModal);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const variant = document.querySelector("variant-selects");
  const sizeChart = document.querySelector("#shopify-section-template--29657564643667__size_chart_variant_cGUgh3");

  if (variant && sizeChart) {
    const wrapper = document.createElement("div");
    wrapper.className = "variant-with-sizechart";

    variant.parentNode.insertBefore(wrapper, variant);

    wrapper.appendChild(variant);
    wrapper.appendChild(sizeChart);
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const observer = new MutationObserver(() => {
    
//     const wishlist = document.querySelector('.xb-wishlist-button');
//     const section = document.querySelector('#shopify-section-template--29657564643667__custom_product_tabs_URb6dP');

//     if (wishlist && section && !wishlist.dataset.moved) {
      
//       section.parentNode.insertBefore(wishlist, section);

//       // prevent multiple moves
//       wishlist.dataset.moved = "true";
//     }

//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {

    const wishlist = document.querySelector('.xb-wishlist-button');
    const share = document.querySelector('.custom-share');
    const section = document.querySelector('#shopify-section-template--29657564643667__custom_product_tabs_URb6dP');

    if (wishlist && share && section && !wishlist.dataset.moved) {

      // create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-actions';

      // insert wrapper before section
      section.parentNode.insertBefore(wrapper, section);

      // move both inside wrapper
      wrapper.appendChild(wishlist);
      wrapper.appendChild(share);

      // prevent re-run
      wishlist.dataset.moved = "true";
    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function toggleDescription(el) {
  const wrapper = el.closest('.product__description');

  const shortDesc = wrapper.querySelector('.desc-short');
  const fullDesc = wrapper.querySelector('.desc-full');

  if (fullDesc.style.display === "none") {
    fullDesc.style.display = "block";
    shortDesc.style.display = "none";

    // ✅ SCROLL TO DESCRIPTION
    fullDesc.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });

  } else {
    fullDesc.style.display = "none";
    shortDesc.style.display = "block";

    // ✅ SCROLL BACK TO SHORT TEXT
    shortDesc.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
    // Function to move the widget
    function moveJudgeMeWidget() {
        var reviewBlock = document.getElementById('shopify-block-AaG5UREpnRzUwWkNpT__judge_me_reviews_review_widget_DDeGay');
        var targetSection = document.getElementById('shopify-section-template--29657564643667__custom_share_7A9cYW');

        if (reviewBlock && targetSection) {
            targetSection.parentNode.insertBefore(reviewBlock, targetSection);
            return true; // moved successfully
        }
        return false; // not ready yet
    }

    // Poll every 300ms until the widget exists
    var interval = setInterval(function() {
        if (moveJudgeMeWidget()) {
            clearInterval(interval); // stop once moved
        }
    }, 300);
});


// 21April 2026
document.addEventListener("change", function (e) {
  if (e.target && e.target.matches('input[type="radio"]')) {
    enableButtons();
  }
});

document.addEventListener("variant:change", function (event) {
  enableButtons();
});

function enableButtons() {
  const btn = document.getElementById("ProductSubmitButton-template--29657564643667__main");

  if (btn) {
    btn.disabled = false;
    btn.classList.remove("disabled");
  }

  document.querySelectorAll(".paypal-button, .paypal-button-row").forEach(function (el) {
    el.style.pointerEvents = "auto";
    el.style.opacity = "1";
  });
}
// end

// document.addEventListener('DOMContentLoaded', function () {

//     const menu = document.querySelector('.header__inline-menu .list-menu');

//     if (!menu) return;

//     const items = menu.querySelectorAll(':scope > li');

//     if (items.length < 2) return;

//     const newUl = document.createElement('ul');
//     newUl.className = 'list-menu list-menu--inline secondary-menu';

//     Array.from(items).slice(-2).forEach(item => {
//         newUl.appendChild(item);
//     });

//     document.querySelector('.header__inline-menu').appendChild(newUl);

// });

// document.addEventListener('DOMContentLoaded', function () {

//     const topBarMenu = document.querySelector('.top-bar-menu');
//     const announcementBar = document.querySelector('.announcement-bar');

//     if (topBarMenu && announcementBar) {
//         announcementBar.appendChild(topBarMenu); // announcement bar ke andar move
//     }

// });

document.addEventListener('DOMContentLoaded', function () {

    const topBarMenu = document.querySelector('.top-bar-menu');
    const announcementBar = document.querySelector('.announcement-bar');

    if (topBarMenu && announcementBar) {

        // 1. Inject CSS via JS (so no flash of wrong UI)
        const style = document.createElement('style');
        style.innerHTML = `
            .top-bar-menu{
                opacity: 0;
                transform: translateY(-10px);
                transition: all 0.25s ease;
            }
        `;
        document.head.appendChild(style);

        // 2. Move element
        announcementBar.appendChild(topBarMenu);

        // 3. Show smoothly after move
        requestAnimationFrame(() => {
            topBarMenu.style.opacity = '1';
            topBarMenu.style.transform = 'translateY(0)';
        });

    }

});
document.addEventListener('DOMContentLoaded', function () {
    const firstSlide = document.querySelector('.slider-banner-sec .slideshow__slide:first-child');

    if (firstSlide) {
        firstSlide.classList.add('first-slide');
    }
});

